import { render } from "./PDFGeneratorSimple.vue?vue&type=template&id=0e12afd4&scoped=true&ts=true"
import script from "./PDFGeneratorSimple.vue?vue&type=script&lang=ts"
export * from "./PDFGeneratorSimple.vue?vue&type=script&lang=ts"

import "./PDFGeneratorSimple.vue?vue&type=style&index=0&id=0e12afd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e12afd4"]])

export default __exports__